//最上面两个人物
export const TopUser = [
  // {
  //   name: "王禹媚",
  //   // title: "创始合伙人",
  //   cover: require("../assets/wang.jpg"),
  //   cover2: require("../assets/wang2.jpg"),
  //   desc1:
  //     "王禹媚，拥有10年以上互联网、消费及娱乐领域投资经验。2017年创立知春资本（Atlas Capital），聚焦于技术改善供需结构的新经济领域，基于多年一二级市场投研和投行的从业经验，深耕产业研究，寻找新兴高成长赛道的卓越公司和优秀创始人，从资本角度助力其成长。",
  //   desc2:
  //     "曾任华泰联合证券董事总经理，成长企业融资部负责人，华泰瑞麟（新产业）基金投委会委员；兼任中信建投基金独立董事。曾任华泰证券研究所董事总经理兼TMT行业负责人，中国国际金融有限公司研究部执行总经理。",
  //   desc3: "拥有北京大学硕士和中国人民大学学士学位。"
  // },
  // {
  //   name: "朱琪祯",
  //   // title: "合伙人",
  //   cover: require("../assets/zhu.jpg"),
  //   cover2: require("../assets/zhu2.jpg"),
  //   desc1:
  //     "朱琪祯，拥有10年以上一、二级及海内外多个市场的丰富投资经验，擅长科技、消费等新兴行业投资。",
  //   desc2:
  //     "曾任华夏基金TMT行业负责人，参与管理产品规模超百亿，投资业绩突出；曾任职于澳大利亚维多利亚州政府基金，负责私募股权部门业务，参与并主导了多个重大项目。",
  //   desc3: "拥有墨尔本大学商科硕士及南京理工大学理学学士学位。"
  // }
];

export const userChines = [
  {
    name: "王禹媚",
    // title: "创始合伙人",
    cover: require("../assets/wang.jpg"),
    cover2: require("../assets/wang2.jpg"),
    desc1:
      "王禹媚，拥有10年以上互联网、消费及娱乐领域投资经验。2017年创立知春资本（Atlas Capital），聚焦于技术改善供需结构的新经济领域，基于多年一二级市场投研和投行的从业经验，深耕产业研究，寻找新兴高成长赛道的卓越公司和优秀创始人，从资本角度助力其成长。",
    desc2:
      "曾任华泰联合证券董事总经理，成长企业融资部负责人，华泰瑞麟（新产业）基金投委会委员；兼任中信建投基金独立董事。曾任华泰证券研究所董事总经理兼TMT行业负责人，中国国际金融有限公司研究部执行总经理。",
    desc3: "拥有北京大学硕士和中国人民大学学士学位。"
  },
  {
    name: "朱琪祯",
    // title: "合伙人",
    cover: require("../assets/zhu.jpg"),
    cover2: require("../assets/zhu2.jpg"),
    desc1:
      "朱琪祯，拥有10年以上一、二级及海内外多个市场的丰富投资经验，擅长科技、消费等新兴行业投资。",
    desc2:
      "曾任华夏基金TMT行业负责人，参与管理产品规模超百亿，投资业绩突出；曾任职于澳大利亚维多利亚州政府基金，负责私募股权部门业务，参与并主导了多个重大项目。",
    desc3: "拥有墨尔本大学商科硕士及南京理工大学理学学士学位。"
  },
  
  {
    name: "曾映龙",
    // title: "副总裁",
    cover: require("../assets/zeng.jpg"),
    cover2: require("../assets/zeng2.jpg"),
    desc1:
      "曾映龙，专注于2C互联网赛道，投资案例：快音、JUMP、绿洲、开黑啦、VYOU、ACE虚拟歌姬、散弹等。",
    desc2:
      "2015年-2017年期间创业，创办网红孵化MCN公司，后利用KOL资源优势探索直播平台 —— 一面APP。",
    desc3: "毕业于深圳大学。"
  },
  {
    name: "解梦晖",
    // title: "COO",
    cover: require("../assets/xie.jpg"),
    cover2: require("../assets/xie2.jpg"),
    desc1:
      "解梦晖，近10年一二级市场娱乐消费领域研究及实战经验。投资案例包括52Toys、橙光、幻音等。",
    desc2:
      "曾任华泰联合证券成长企业融资部业务董事，华泰创新投资业务董事。曾就职华泰证券和中金公司，任传媒与互联网行业分析师。",

    desc3: "拥有北京大学金融工程硕士学位。"
  },

  {
    name: "付翀",
    // title: "中台主管",
    cover: require("../assets/fu.jpg"),
    cover2: require("../assets/fu2.jpg"),
    desc1: "付翀，负责基金运营管理工作。",
    desc2:
      "加入知春资本前，曾就职于鸿道电影金融，关注影视娱乐方向的投资及市场研究。也曾在工商银行北京分行工作，积累了丰富的公司风控合规经验。",
    desc3: "拥有南开大学经济学硕士学位。"
  },
  {
    name: "李若飞",
    // title: "中台主管",
    cover: require("../assets/fei.jpg"),
    cover2: require("../assets/fei1.jpg"),
    desc1:
      "李若飞，专注新能源产业链成长赛道，对上、中、下游等细分板块具备较深刻的理解以及个股挖掘能力，擅长结合产业发展周期及市场风格把握超额投资机会。",
    desc2: "加入知春资本前，曾在方正富邦基金，国盛证券担任行业分析师。",
    desc3: "拥有南开大学金融学硕士学位，重庆大学工学学士学位。"
  },
  {
    name: "林臻",
    cover: require("../assets/lin.jpg"),
    cover2: require("../assets/lin2.jpg"),
    desc1:
      "林臻，聚焦于互联网新经济赛道，具备良好的对成长股自下而上的挖掘能力，擅长从新型产业发展动态中寻找投资机会。",
    desc2: "加入知春资本前，曾在易方达（香港）资产管理公司担任研究员。",
    desc3:
      "拥有香港科技大学理学硕士学位，中国人民大学经济学学士学位。于2019年通过CFA 3级。"
  },
  {
    name: "刘硕",
    // title: "中台主管",
    cover: require("../assets/shuo.jpg"),
    cover2: require("../assets/shuo2.jpg"),
    desc1: "刘硕，负责二级市场分析研究工作，专注于为公司提供数据与模型的支持。",
    desc2:
      "加入知春资本前，曾在中信里昂证券澳大利亚办公室担任股票分析师助理，负责财务建模等工作。",
    desc3: "毕业于新南威尔士大学商学院，获得金融学硕士学位。2019年通过CFA 3级。"
  },
  {
    name: "蒋凌子",
    // title: "中台主管",
    cover: require("../assets/jiang.jpg"),
    cover2: require("../assets/jiang2.jpg"),
    desc1:
      "蒋凌子，专注消费与教育领域投资。对食品饮料、线下连锁、宠物、教育等行业有深度研究及广泛项目覆盖，并积累了多年项目投后管理经验。",
    desc2: "加入知春资本之前，曾就职于清科创投。",
    desc3: "拥有西南财经大学金融学硕士学位。"
  },
  {
    name: "宋仁杰",
    // title: "中台主管",
    cover: require("../assets/jie.jpg"),
    cover2: require("../assets/jie2.jpg"),
    desc1:
      "宋仁杰，专注于消费领域投资，发掘由新人群、新渠道带来的消费行为变化带来投资机会。",
    desc2:
      "在加入知春资本前，曾就职于青山资本。在校期间作为创业公司的早期成员深度参与过项目落地、投融资等业务。",
    desc3: "毕业于北京理工大学。"
  },
  {
    name: "金效滢",
    // title: "中台主管",
    cover: require("../assets/jin.jpg"),
    cover2: require("../assets/jin2.jpg"),
    desc1: "金效滢，专注于2c互联网领域投资。",
    desc2:
      "加入知春资本前，金效滢曾于在校期间创办和参与多家创业公司，完成业务落地、收购退出等多项工作。",
    desc3: "毕业于中国传媒大学，拥有音乐传播及法学双学位。"
  },
  {
    name: "陈佳骊",
    // title: "中台主管",
    cover: require("../assets/jia.jpg"),
    cover2: require("../assets/jia.jpg"),
    desc1: "陈佳骊，负责基金运营的风控合规相关工作。",
    desc2:
      "加入知春资本前，曾就职于安永华明会计师事务所从事审计、咨询工作，后就职于阳光保险资管、恒天财富，积累多年风控合规工作经验。",
    desc3: "中国人民大学工商管理硕士、中央财经大学管理学学士。拥有CPA资格证书。"
  },

];

// 合作伙伴
export const teamChines = [
  {
    name: "诺信创联",
    desc: "国内领先的医药数字化营销服务商",
    cover: require("../assets/1.png"),
    url: "http://www.naxions.com/",
    width: "218px",
    height: "88px"
  },
  {
    name: "橙光",
    desc: "国内最大的互动阅读平台",
    cover: require("../assets/2.png"),
    url: "https://www.66rpg.com/",
    width: "166px",
    height: "54px"
  },
  {
    name: "小佩宠物",
    desc: "宠物用品领导品牌+一站式宠物服务平台",
    cover: require("../assets/3.png"),
    url: "https://www.petkit.com/",
    width: "166px",
    height: "71px"
  },
  {
    name: "Jump",
    desc: "围绕游戏等线上娱乐展开的UGC内容社区",
    cover: require("../assets/jump.png"),
    url: "http://www.jump-game.com/",
    width: "192px",
    height: "70px"
  },
  {
    name: "百果园",
    desc: "中国规模最大的水果新零售连锁企业",
    cover: require("../assets/10.png"),
    url: "https://www.pagoda.com.cn/",
    width: "118px",
    height: "119px"
  },
  {
    name: "52Toys",
    desc: "潮玩行业的领军企业",
    cover: require("../assets/14.jpg"),
    url: "http://www.52toys.com/",
    width: "191px",
    height: "190px"
  },

  {
    name: "NewBanker",
    desc: "国内领先的财富管理行业服务平台",
    cover: require("../assets/5.png"),
    url: "https://www.newbanker.com/",
    width: "201px",
    height: "58px"
  },
  {
    name: "绿洲",
    desc: "领先的VR内容平台及交流社区",
    cover: require("../assets/6.png"),
    url: "https://www.oasis.world/",
    width: "150px",
    height: "38px"
  },

  {
    name: "雅观科技（Argrace）",
    desc: "智慧人居物联网平台",
    cover: require("../assets/13.png"),
    url: "http://www.argrace.ai/",
    width: "191px",
    height: "44px"
  },

  {
    name: "安信智控",
    desc: "物理安全及智能计算整体方案服务商",
    cover: require("../assets/12.png"),
    url: "",
    width: "115px",
    height: "97px"
  },
  {
    name: "Vyou",
    desc: "基于虚拟形象的社交娱乐App",
    cover: require("../assets/11.png"),
    url: "https://www.vyou.xyz/",
    width: "92px",
    height: "92px"
  },
  {
    name: "幻音音乐",
    desc: "国内最大的95后音乐社区",
    cover: require("../assets/15.png"),
    url: "http://www.huanmusic.com/",
    width: "192px",
    height: "40px"
  },
  {
    name: "散弹",
    desc: "面向00后的游戏型对线兴趣社区",
    cover: require("../assets/9.png"),
    url: "https://sandanapp.com/",
    width: "92px",
    height: "102px"
  },
  {
    name: "精准课堂",
    desc: "面向下沉幼儿园的外教双师课堂",
    cover: require("../assets/16.png"),
    url: "https://www.51cth.com/",
    width: "152px",
    height: "47px"
  },
  {
    name: "开黑啦",
    desc: "游戏玩家专属的文字、语音和组队工具",
    cover: require("../assets/8.png"),
    url: "https://kaiheila.cn/",
    width: "180px",
    height: "41px"
  },

  {
    name: "352",
    desc: "聚焦家庭空气和水净化场景的创新驱动型品牌",
    cover: require("../assets/4.png"),
    url: "http://www.352air.com/",
    width: "172px",
    height: "62px"
  },

  {
    name: "Q大",
    desc: "中国偶像应援的文化品牌",
    cover: require("../assets/7.png"),
    url: "",
    width: "169px",
    height: "68px"
  },
  {
    name: "原石星球",
    desc: "跨境珠宝首饰快时尚品牌",
    cover: require("../assets/17.png"),
    url: "http://www.boomjoo.co",
    width: "169px",
    height: "42.25px"
  },
  {
    name: "ACE虚拟歌姬",
    desc: "AI赋能的音乐创作平台",
    cover: require("../assets/18.png"),
    url: "",
    width: "89px",
    height: "88px"
  },
  {
    name: "快音",
    desc: "基于推荐的音乐ugc平台",
    cover: require("../assets/19.png"),
    url: "http://kaixinyf.cn",
    width: "89px",
    height: "89px"
  },
  {
    name: "宇安电子",
    desc: "致力成为全球领先的电子战、电磁试验训练系统解决方案供应商",
    cover: require("../assets/yu.png"),
    url: "http://www.jsyadz.cn/",
    width: "205px",
    height: "58px"
  },
  {
    name: "Gemsouls",
    desc: "人工智能驱动的互动娱乐平台",
    cover: require("../assets/20.png"),
    url: "http://www.gemsouls.com",
    width: "150px",
    height: "150px"
  }
  // {
  //   name: "",
  //   desc: "敬请期待",
  //   cover: "",
  //   url: "",
  //   width: "",
  //   height: ""
  // },
  // {
  //   name: "",
  //   desc: "敬请期待",
  //   cover: "",
  //   url: "",
  //   width: "",
  //   height: ""
  // }
];



// WEBPACK FOOTER //
// ./src/util/text.js